import {
  CellData,
  Field,
  BindingDataItem,
  ImageValue,
  Dimensions,
  CIRCLE,
  SQUARE,
  PORTRAIT,
  LANDSCAPE,
} from './TableTypes'

export interface TableState {
  columns: string[]
  data: {
    id: number
    cells: CellData[]
  }[]
}

export const formatLocation = (field: CellData): string => {
  if (!field.value) {
    return ''
  }

  const bindingFormat = field.binding?.format?.locationFormat ?? ''

  if (
    typeof bindingFormat !== 'string' ||
    !bindingFormat.length ||
    bindingFormat.length === 0
  ) {
    return ''
  }

  const keyPath = bindingFormat?.split('.') ?? ''

  const { value } = field

  if (keyPath.length === 1) {
    return value[keyPath[0]] ?? ''
  }

  return value[keyPath[0]]?.[keyPath[1]] ?? ''
}

export const getBindingData = (
  fields: Field[],
  bindingData: BindingDataItem[]
): TableState => {
  const columns = fields.map(field => field.label)

  if (fields.length === 0) {
    return { columns: [], data: [] }
  }

  const data = bindingData.map(bindingDataItem => {
    const cells = fields.map(field => ({
      fieldId: field.fieldId,
      type: field.type,
      value: bindingDataItem[field.fieldId],
      label: field.label,
      binding: field.binding,
    }))

    return {
      id: bindingDataItem.id,
      cells,
    }
  })

  return { columns, data }
}

export const getImageSize = (
  imageValue: ImageValue,
  ratio: string
): Dimensions => {
  switch (ratio) {
    case CIRCLE:
      return { width: 50, height: 50 }
    case SQUARE:
      return { width: 50, height: 50 }
    case PORTRAIT:
      return { width: 50, height: 75 }
    case LANDSCAPE:
      return { width: 75, height: 50 }
    default:
      return { width: imageValue.width, height: imageValue.height }
  }
}
